<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="title"><h1>免费在线句子检查工具</h1></div>
                    <p>Trinka的句子检查工具由人工智能（AI）驱动，能够实时检查句子中是否存在任何类型的复杂错误。<br/>Trinka不仅可以纠正语法错误，还可以检查您写作中的句子结构和标点符号等是否正确。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-english-grammar-checker></app-english-grammar-checker>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<div class="gcBrowserSection">
    <div class="container">
        <div class="row">
            <div class="gcBrowserContainer">
                <h2>Trinka的句子检查工具插件让您随时随地都能准确写作。</h2>
                <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"><img src="assets/images/NewChromeIcon.svg" alt=""> 安装谷歌插件</a>
                <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank"><img src="assets/images/NewFirefoxIcon.svg" alt=""> 安装火狐插件</a>
                <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"><img src="assets/images/EdgeWhite_BGAndOutline.svg" alt=""> 安装Edge插件</a>
            </div>
        </div>
    </div>
</div>

<div class="signupmobile" style="display: none !important;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinkaPluginGCSection">
                    <h2>您的免费Trinka账号</h2>
                    <p>每个月为您免费检查多达5000个单词的写作，让您的语言和写作风格得到全面提升。</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">立即注册！</a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>最佳免费在线句子检查工具</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Trinka的免费在线句子检查工具可以正确构建您的句子，并使您的写作易于理解。</p>
                    <p>Trinka能够实时修复句子结构和措辞中存在的问题。Trinka能够识别任何被错误放置的单词以及拼写错误，并提供正确的替代方案。</p>
                    <div class="most_suited_point">
                        <ul>
                            <li>高级句子检查和更正</li>
                            <li>高级语法检查</li>
                            <li>免费享受</li>
                            <li>根据上下文更正拼写</li>
                        </ul>
                    </div>
                    <p>Trinka的在线句子检查工具可以检测句子错误并提供带有解释的建议，让您更好地理解。</p>
                    <p>注册以免费解锁更多功能！</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank" class="cta-btn">开始使用</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckSection">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-4">
                <div class="grammarCheckHeadingSection">
                    <h2>谁可以使用Trinka的句子检查工具？</h2>
                </div>
            </div>
            <div class="col-md-8">
                <div class="grammarCheckTextContent">
                    <p>不管您是学生、研究人员、作者、自由撰稿人还是博主，任何人都可以使用Trinka的高级句子检查工具。我们的句子检查工具能够检查所有类型的内容。</p>
                </div>
            </div>
        </div> 
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>Trinka句子检查工具的主要功能</h2>
                    <div class="HeadingSubLine"></div>
                    <!-- <p>Enhance and check your writing instantly with the best English grammar checker. Trinka's advanced
                        checking feature highlights mistakes and provides contextual suggestions that make your writing
                        rise and shine.</p> -->
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>句子结构</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka能够检查您的句子结构、词序是否正确以及是否有缺失的单词，让您的写作清晰易读。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>Coelomic fluid samples were <span class="wrong_text">analyzed</span>&nbsp;<span class="right_text"> analyzed using</span> various tools.</p>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>高级语法检查</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka超越了基本的语法和拼写检查，它能够评估您的写作是否存在高级语法错误并且提供语言增强建议，以提高您的写作质量。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Syntax</h4> -->
                            <p>Neither the healthy individuals nor the patient <span
                                class="wrong_text">recognize</span> <span
                                class="right_text"> recognizes</span> the visual discrepancies.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>用法和样式</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka能够检测不正确或带有偏见的词汇，并且建议准确的单词和正式的语气。帮助您用精确和包容的语言给读者留下深刻印象。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Advance Spelling</h4> -->
                            <p>However, this method is novel and is
                                <span class="wrong_text">very much</span>&nbsp;
                                <span class="right_text">considerably</span> different from the classical method.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>标点符号和拼写检查</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>除了句子和语法检查外，Trinka还提供增强的标点符号检查以提高作品的可读性。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p><span class="wrong_text">Importantly</span>&nbsp;<span
                                class="right_text">Importantly,</span> there were no <span class="wrong_text">observble</span>&nbsp;
                                <span class="right_text">observable</span>
                                adverse effects</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="use_trinka_other_app">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="use_trinka_content">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>在其他应用程序<br />中使用Trinka</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/wordAdd_in.svg" alt="">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/NewChromeIcon.svg" alt="">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/NewFirefoxIcon.svg" alt="">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/safari_logo.png" alt="">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="moreEffectiveSection">
    <div class="container">
        <div class="row flex-row-reverse align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>Trinka的免费句子检查工具是如何工作的？</h2>
                    <p>Trinka的句子检查工具从不同领域研究文章中的数百万个优秀句子中学习。它能够检查您的句子结构、措辞、词序和用法，确保您的句子正确、连贯且完整。Trinka的句子检查工具易于使用，只需添加您的内容，它就可以建议所有语法增强和更正，无论错误有多小。</p>
                    <p>Trinka可以帮您纠正句子中所有类型的语法和拼写错误，从而自信地与读者交流。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="assets/images/WritingMoreEffective.png" alt="">
                </div>
            </div>
            
        </div>
        <div class="row colunmChangesSection align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>为什么要使用句子检查工具？</h2>
                    <p>Trinka的句子检查工具由人工智能（AI）驱动，可以识别句子中的不一致之处，以及语法、标点符号和拼写错误。Trinka使用最新的机器学习和自然语言处理技术开发而成，可提供最准确的建议。</p>
                    <p>使用我们的句子检查工具来校对您的内容，不仅使您要表达的信息和科学内容更加清晰，还可以为您节省大量时间从而专注于更深层次的写作问题。我们的句子检查工具适用于所有类型的写作，包括技术写作，处理复杂和困难的单词也游刃有余。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="assets/images/LearnGrammarwithTrinka.png" alt="">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>Testimonials</h2>
                    <p>Check what users are saying about Trinka</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked
                        earlier with Grammarly. I was pleasantly surprised to see such a product from India!</p>
                    <div class="testimonals_footer">
                        <p>Radiologist, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>First, I love Trinka. Congratulations on developing something that extensively aids editing,
                        especially critical grammar conventions and word count reductions.</p>
                    <div class="testimonals_footer">
                        <p>Academic Editor, USA</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar
                        checker I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is
                        widely used in academia.</p>
                    <div class="testimonals_footer">
                        <p>PhD Scholar, UK</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center testi">
                <div class="GCTestmonials">
                    <h2>使用感言</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/James-Smith.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我一下就爱上Trinka了。祝贺你们开发出这个可以大幅协助编辑的程序，尤其是符合重要的语法惯例和具备精简字数功能的工具。
                                                    </p>
                                                    <p class="authorNameText">James Smith</p>
                                                    <span class="authorDesignationText">学术编辑, 美国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">对于说其他语言的人来说，用正确的英语语法和风格编写文章不是一件容易的事。如果没有辅助功能，尤其是学术写作，很难在文件中发现小错误。我尝试将TrinkaAI作为自动更正工具，并对建议的更正和反馈感到非常满意。通过反馈，能了解为什么必须考虑建议的更改。</p>
                                                    <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                    <span class="authorDesignationText">物理和数学博士, 墨西哥</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我使用Trinka两个多月了。我主要用它来改进我为国内和国际生物医学期刊撰写的科学手稿的语言、语法和句法。界面很用户友好，并且软件高效且好用。根据需要编辑手稿的不同选项有助于决定我需要关注的地方。自动编辑的帮助很大，带有修订历史的补充页面很有用。Trinka一直在更新，我写这篇文章时就注意到添加了一个新功能“一致性”。最好的部分是所有这些都是完全免费的。我强烈鼓励作者和研究人员，特别是那些英语不好的人尝试一下，亲眼目睹惊人的结果。</p>
                                                    <p class="authorNameText">Farooq Rathore博士</p>
                                                    <span class="authorDesignationText">助理教授兼系主任, 巴基斯坦</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Georgieva-Milena.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka.ai是我最喜欢的语法和拼写编辑。该应用程序使用效果好，快速而明确！完全满意！</p>
                                                    <p class="authorNameText">Milena Georgieva</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">这是一个超越Grammarly的语法检查工具！我用Trinka重新检查了用Grammarly检查过一些文件。看到来自印度的如此优越产品，我感到非常惊喜！</p>
                                                    <p class="authorNameText">Dinesh Gupta</p>
                                                    <span class="authorDesignationText">放射科医师, 印度</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Edith-Davies.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我已经测试过Trinka，并对其出色的功能印象深刻。它比我使用的语法检查器做得更好。做得好！我已经告诉我研究实验室的同事使用Trinka。希望在学术界得到广泛应用。</p>
                                                    <p class="authorNameText">Edith Davies</p>
                                                    <span class="authorDesignationText">博士生, 英国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Noor-Al-rishi.png" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka AI建议的更正和反馈令我惊喜。使用简单，非常有益。</p>
                                                    <p class="authorNameText">Noor Al-rishi</p>
                                                    <span class="authorDesignationText">化学学者, 沙特阿拉伯</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Nwaji-Jude.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">使用Trinka是美妙的体验，如果不使用它评估稿件，我几乎无法提交任何手稿。总之，Trinka成了我的是救命稻草。</p>
                                                    <p class="authorNameText">Nwaji Jude</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我喜欢使用Trinka作为我编辑文稿的最终检查。它确实有助于找到在编辑过程中漏掉的剩余错误。我真的很喜欢这个平台。大拇指向下这个按钮非常有用。
                                                    </p>
                                                    <p class="authorNameText">Stumpf Curtis</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dyke-Gareth.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我认为Trinka.ai是一个非常有趣且很有发展潜力的主意，尤其是对于编辑/出版社/期刊。我使用这个平台检查我的编辑工作，非常有用。</p>
                                                    <p class="authorNameText">Gareth Dyke</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我对整体表现感到满意。我使用Grammarly已经有很长一段时间了，但是在学术或技术写作方面，Trinka绝对是更好的选择。学术文件设置和自动文件编辑是我最喜欢的功能。</p>
                                                    <p class="authorNameText">Bhargava Sharma</p>
                                                    <span class="authorDesignationText">流行病学家, 印度</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Ralph-Bailey.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka已成为我语法校正的首选工具。人工智能驱动的更正和语言增强使写作变得更加容易。现在，我可以更专注于研究，而不是纠正文稿中的错误。</p>
                                                    <p class="authorNameText">Ralph Bailey</p>
                                                    <span class="authorDesignationText">神经科医生, 美国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Thomas-Andres.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">基于AMA风格指南的语法纠正和建议真的令人印象深刻！Trinka确实是医学写作最好的语法校正工具。
                                                    </p>
                                                    <p class="authorNameText">Thomas Andres</p>
                                                    <span class="authorDesignationText">心脏学专家, 巴西</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


    
<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>句子检查工具让您的写作更加完美！</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank" id="grammerSignUpButton">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>免费注册！</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckQuestions">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="GCQuestions">
                    <h2>Trinka的句子检查工具常见问题解答</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
                <div class="row">
                    <div class="offset-md-1 col-md-10">
                        <div class="answersSections">
                            <div class="accordion" id="QeustionGrammarChecks">
                                <div class="card">
                                    <div class="card-header" id="QuestionGCOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCOneContent" aria-expanded="true"
                                            aria-controls="QuestionGCOneContent">
                                            在哪里可以检查我的句子？</a>
                                    </div>
        
                                    <div id="QuestionGCOneContent" class="collapse show"
                                        aria-labelledby="QuestionGCOne" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>只需将您的内容粘贴到此页面的编辑器中，然后单击“检查我的写作”，Trinka将突出显示所有句子结构和使用错误，并提供准确的上下文建议。</p>
                                        </div>
                                    </div>
                                </div>        
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwoContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwoContent">如何检查我句子中的语法是否正确？</a>
                                    </div>
        
                                    <div id="QuestionGCTwoContent" class="collapse"
                                        aria-labelledby="QuestionGCTwo" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>使用Trinka的句子检查工具，您只需单击几下即可检查您的写作是否存在语法和标点符号错误，以及单词是否使用正确。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent">Trinka的句子检查工具可以免费使用吗？</a>
                                    </div>
        
                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>绝对免费！您只需使用此页面上的编辑器即可检查和更正您的句子。如果您想检查更长的文档，可以在<a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">此处注册</a>并免费使用更多功能。</p>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="card">
                                    <div class="card-header" id="QuestionGCFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFourContent" aria-expanded="true"
                                            aria-controls="QuestionGCFourContent">我可以检查不同网站上的句子吗？</a>
                                    </div>
        
                                    <div id="QuestionGCFourContent" class="collapse"
                                        aria-labelledby="QuestionGCFour" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>可以！您只需在谷歌Chrome、火狐Firefox或微软Edge浏览器上安装我们的<a [routerLink]="['/browser-plugin']">插件</a>，就可以在任何网站上使用Trinka的句子检查工具。</p>
                                        </div>
                                    </div>
                                </div>

                                
        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
